import React from "react";
import { Text, Button } from "@networkraildigitalfactory/components";
import { CloseObjectivesModal } from "../Modals";
import { useObjectivesList } from "../../hooks/closeObjectives";
import useCloseObjectivesModal from "../../hooks/modals/useCloseObjectivesModal";
import styles from "./CloseObjectiveList.module.css";

const CloseObjectiveList = () => {
  const { isModalOpen, toggleModal } = useCloseObjectivesModal();

  const {
    values,
    isFetching,
    allItemsChecked,
    selectedValues,
    selectAll,
    toggleItem,
    content,
  } = useObjectivesList();

  const { noDataMsg } = content;

  return (
    <>
      {!isFetching && values.length ? (
        <>
          <div className={styles.background}>
            <div className={styles.headerText}>
              <Text wrapper="h2" type="header" style={{ fontSize: "20px", color: "#000000" }}>
                Select the objectives you wish to close:
              </Text>
            </div>
            <div className={styles.objectives_row}>
              <label htmlFor="select-all" className={styles.checkContainer}>
                <input
                  id="select-all"
                  className={styles.checkbox}
                  type="checkbox"
                  checked={allItemsChecked}
                  label="Receive all notifications"
                  onChange={selectAll}
                />
                <span className={styles.checkmark}></span>
              </label>
              <Text wrapper="span" style={{ color: "#37519D", fontSize: "16px" }}>
                Select All
              </Text>
            </div>
            {values.map((objective, index) => {
              const { label, status, dueDate, checked } = objective;
              return (
                <div key={index} className={styles.objectives_row}>
                  <label htmlFor={label} className={styles.checkContainer}>
                    <input
                      id={label}
                      className={styles.checkbox}
                      type="checkbox"
                      checked={checked}
                      label={label}
                      onChange={(e) => toggleItem(e, index)}
                    />
                    <span className={styles.checkmark}></span>
                  </label>
                  <div className={styles.textStyle}>
                    <Text wrapper="span" style={{ color: "#323432", fontSize: "16px" }}>
                      <span className={styles.content_noStyle}>{label}: </span>
                      {status ? (
                        <>
                          <span className={styles.content_bold}>status: </span>
                          <span className={styles.noStyle}>{status}, </span>
                        </>
                      ) : (
                        ""
                      )}
                      {dueDate ? (
                        <>
                          <span className={styles.content_bold}>due date: </span>
                          <span className={styles.noStyle}>{dueDate} </span>
                        </>
                      ) : (
                        ""
                      )}
                    </Text>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles.close_objective_Btn}>
            <Button
              style={{
                backgroundColor: selectedValues.length ? "#37519D" : "#727272",
              }}
              disabled={!selectedValues.length}
              text="Close objectives"
              onClick={toggleModal}
            />
          </div>
          <CloseObjectivesModal
            show={isModalOpen}
            close={toggleModal}
            closeNotificationList={selectedValues}
          />
        </>
      ) : (
        <div className={styles.noDataMessage}>{noDataMsg}</div>
      )}
    </>
  );
};

export default CloseObjectiveList;
